import React from 'react';
import S from '../../UmbracoForm.styles';
const Textarea = React.forwardRef(({ field, error, ...otherProps }, ref) => {
    return (React.createElement(S.Field, { className: error?.message && 'invalid' },
        React.createElement(S.Label, { htmlFor: field.alias }, field.caption),
        !field.required && React.createElement(S.RequiredLabel, null, "(optional)"),
        React.createElement(S.Textarea, { ref: ref, id: field.alias, placeholder: field.placeholder, required: field.required, ...otherProps }),
        error && React.createElement(S.Error, null, error.message)));
});
Textarea.displayName = 'Textarea';
export default Textarea;
